import { ThemeEvents } from '@theme/events';
import { DialogOpenEvent } from '@theme/dialog';

/**
 * @param {Date} startDate
 * @param {number} workingDays
 * @returns {Date}
 */
function addWorkingDays(startDate, workingDays) {
  const date = new Date(startDate);

  while (workingDays > 0) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && day !== 6) {
      workingDays--;
    }
  }

  return date;
}

/** @returns {string} e.g. "5 giu - 10 giu" */
function getDeliveryEstimateText() {
  const now = new Date();
  const dispatchDelay = now.getHours() < 12 ? 1 : 2;
  const dispatchDate = addWorkingDays(now, dispatchDelay);
  const minDeliveryDate = addWorkingDays(dispatchDate, 1);
  const maxDeliveryDate = addWorkingDays(dispatchDate, 4);
  const months = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
  const formatDate = (date) => `${date.getDate()} ${months[date.getMonth()]}`;

  return `${formatDate(minDeliveryDate)} - ${formatDate(maxDeliveryDate)}`;
}

/** @returns {string} */
function updateDeliveryEstimate() {
  const deliveryText = getDeliveryEstimateText();
  document.querySelectorAll('.cart-delivery-date-text').forEach((el) => {
    el.textContent = deliveryText;
  });
  return deliveryText;
}

function scheduleUpdateDeliveryEstimate() {
  // Run after sync cart morph (microtasks run before morph that follows dispatchEvent).
  setTimeout(updateDeliveryEstimate, 0);
  // Run again after async section re-render (e.g. discount apply).
  setTimeout(updateDeliveryEstimate, 150);
}

function bindCartDrawerOpen() {
  document.querySelectorAll('cart-drawer-component').forEach((drawer) => {
    if (drawer.dataset.deliveryEstimateBound === 'true') return;
    drawer.dataset.deliveryEstimateBound = 'true';
    drawer.addEventListener(DialogOpenEvent.eventName, scheduleUpdateDeliveryEstimate);
  });
}

updateDeliveryEstimate();
bindCartDrawerOpen();
document.addEventListener(ThemeEvents.cartUpdate, scheduleUpdateDeliveryEstimate);
document.addEventListener(ThemeEvents.discountUpdate, scheduleUpdateDeliveryEstimate);
document.addEventListener('theme:section-morphed', scheduleUpdateDeliveryEstimate);
document.addEventListener(ThemeEvents.cartUpdate, bindCartDrawerOpen);
